// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { DefaultButton, IButtonProps, IButtonStyles, IStyle, ITheme, mergeStyles, useTheme } from '@fluentui/react';

export const headerLightButtonStyles: IButtonStyles = {
  textContainer: {
    // Only show icon on mobile and narrow devices
    '@media only screen and (max-width: 600px)': {
      display: 'none'
    }
  },
  root: {
    '@media only screen and (max-width: 600px)': {
      minWidth: '3rem',
      padding: 0
    }
  }
};

const lightBorderButtonStyles = (theme: ITheme): IStyle => ({
  fontWeight: '600',
  fontSize: '0.875rem',
  borderColor: theme.palette.neutralQuaternaryAlt
});

export const LightBorderButton = (props: IButtonProps): JSX.Element => {
  const theme = useTheme();
  const styles = mergeStyles(lightBorderButtonStyles(theme));

  return <DefaultButton className={styles} {...props} />;
};
